import React from 'react';
import { Html5Qrcode } from 'html5-qrcode';
import "./qrScanner.css";
import {aisinoInfoModal} from "../../../common/modal/AisinoModalMethod";
import {getLanguage} from "../../../source/js/common";
const commonLan = require('../../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');

class QrScanner extends React.Component {
    constructor(props) {
        super(props);
        this.scannerRef = null;
        this.fileInputRef = React.createRef();
    }

    componentDidMount() {
    }

    startScanner(){
        this.initScanner();
    }

    componentWillUnmount() {
        if (this.scannerRef) {
            this.scannerRef.stop().catch(error => {
                console.error('清理失败:', error);
            });
        }
    }


    initScanner (){
        const that= this;
        that.scannerRef = new Html5Qrcode('qr-scanner');
        const config = {
            fps: 5,
            qrbox: { width: 250, height: 250 },
        };
        const handleSuccess = (decodedText, decodedResult) => {
            that.scannerRef.stop();
            if(that.props.resHandle){
                that.props.resHandle(decodedText);
            }
        };
        const handleError = (error) => {
            console.log(error)
        };
        that.scannerRef.start(
            { facingMode: "environment"},
            config,
            handleSuccess,
            handleError
        );
    };

    scanCancel(){
        const that= this;
        that.scannerRef.stop();
        that.props.scanCancel();
    }


    handleFileSelect = () => {
        this.fileInputRef.current?.click();
    };

    handleFileChange = (e) => {
        const that= this;
        if (e.target.files.length > 0) {
            const qrReader = new Html5Qrcode('qr-reader');
            qrReader.scanFile(e.target.files[0], true)
                .then(decodedText => {
                    this.fileInputRef.current.value = '';
                    if(that.scannerRef){
                        that.scannerRef.stop();
                    }
                    if(that.props.resHandle){
                        that.props.resHandle(decodedText);
                    }
                })
                .catch(err => {
                    // failure, handle it.
                    aisinoInfoModal(commonLan.qrScannerTip)
                });
        }
    };

    render() {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'gray', // 可以替换为你想要的背景色
            }}>
                <div style={{ position: 'relative' }}>
                    <div id="qr-scanner" style={{ height:'100%', width: '100%',marginTop:"20px" }} />
                    <div id="qr-reader" style={{ display: 'none' }}/>
                    <div className={"buttonArea"}>
                        <button onClick={this.handleFileSelect}
                                className={"button1"}>
                            {commonLan.selectButton.label}
                        </button>
                        <button onClick={()=>this.scanCancel()}
                                className={"button2"}>
                            {commonLan.cancelButton.label}
                        </button>
                    </div>

                    <input
                        ref={this.fileInputRef}
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={this.handleFileChange}
                    />
                </div>
            </div>
        );
    }
}

export default QrScanner;
